import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5aed57d63733b95f3de2b7f8238d33a4.jpg"
          alt="İzmir Vize Danışmanlığı Ofis"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/70 via-navy-900/60 to-navy-900/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid lg:grid-cols-5 gap-12 items-center">
          {/* Left Content - 60% */}
          <div className="lg:col-span-3 space-y-8">
            {/* Badge */}
            <div className="inline-block">
              <span className="inline-flex items-center px-5 py-2 bg-navy-900 text-cream-100 text-xs font-semibold tracking-widest uppercase rounded-full">
                <h1 className="text-xs">İzmir Vize Danışmanlığı | +10 Yıl Deneyim</h1>
              </span>
            </div>

            {/* Main Heading */}
            <div className="space-y-4">
              <h2 className="font-display text-5xl md:text-6xl lg:text-7xl text-white leading-tight">
                <span className="font-light">Yurt Dışı Seyahat</span>
                <br />
                <span className="font-bold">Planlarınızda</span>
                <br />
                <span className="font-light">Güvenilir Çözüm</span>
              </h2>
            </div>

            {/* Description */}
            <p className="text-cream-200 text-lg md:text-xl leading-relaxed max-w-2xl">
              <strong>İzmir Vize Danışmanlık</strong> hizmetlerimizle vize sürecinizi doğru yönetin. 
              <strong>Deneyimli ekip, iade garantisi, profesyonel evrak takibi</strong> ve güvenilir danışmanlık.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link
                to="/iletisim"
                className="group inline-flex items-center justify-center px-8 py-4 bg-navy-900 text-cream-100 rounded-full font-semibold text-base hover:bg-navy-800 transition-all hover:scale-105 shadow-xl whitespace-nowrap"
              >
                Hemen Başvur
                <div className="ml-3 w-8 h-8 flex items-center justify-center bg-orange-600 rounded-full group-hover:rotate-45 transition-transform">
                  <i className="ri-arrow-right-line text-white"></i>
                </div>
              </Link>
              <Link
                to="/hakkimizda"
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-cream-100 text-cream-100 rounded-full font-semibold text-base hover:bg-cream-100 hover:text-navy-900 transition-all whitespace-nowrap"
              >
                10+ Yıl Deneyim
              </Link>
            </div>
          </div>

          {/* Right Visual - 40% */}
          <div className="lg:col-span-2 relative">
            <div className="relative">
              {/* Main Card - Passport */}
              <div className="relative z-30 transform -rotate-6 hover:rotate-0 transition-transform duration-500">
                <div className="bg-white rounded-2xl shadow-2xl p-6 w-full h-64 flex items-center justify-center">
                  <img
                    src="https://readdy.ai/api/search-image?query=Professional%20passport%20document%20with%20visa%20stamps%20on%20clean%20white%20background%2C%20official%20travel%20document%2C%20international%20visa%20pages%2C%20detailed%20passport%20design%2C%20high%20quality%20business%20photography%2C%20navy%20blue%20and%20cream%20color%20accents&width=400&height=300&seq=passport-001&orientation=landscape"
                    alt="Pasaport ve Vize"
                    className="w-full h-full object-cover object-top rounded-lg"
                  />
                </div>
              </div>

              {/* Second Card - Visa Stamp */}
              <div className="absolute top-12 -right-8 z-20 transform rotate-12 hover:rotate-6 transition-transform duration-500">
                <div className="bg-cream-100 rounded-2xl shadow-xl p-6 w-48 h-48 flex items-center justify-center">
                  <div className="text-center">
                    <i className="ri-passport-line text-6xl text-navy-900 mb-2"></i>
                    <p className="text-navy-900 font-semibold text-sm">Vize Onayı</p>
                  </div>
                </div>
              </div>

              {/* Third Card - Plane Ticket */}
              <div className="absolute -bottom-8 -left-8 z-10 transform rotate-6 hover:rotate-3 transition-transform duration-500">
                <div className="bg-navy-900 rounded-2xl shadow-xl p-6 w-56 h-40 flex items-center justify-center">
                  <div className="text-center">
                    <i className="ri-flight-takeoff-line text-5xl text-cream-100 mb-2"></i>
                    <p className="text-cream-100 font-semibold text-sm">Seyahat Hazır</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="flex flex-col items-center space-y-2 animate-bounce">
          <span className="text-cream-200 text-xs uppercase tracking-wider">Keşfet</span>
          <i className="ri-arrow-down-line text-cream-200 text-2xl"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;